import createAxios from './axios';

const request = createAxios()

export default request;